import { useLoginAdmin } from '../../../hooks/auth/useLoginAdmin';
import { useLoginForm } from '../../../hooks/auth/useLoginForm';
import { LoginForm } from '../../organisms/authentication/LoginForm';


export const LoginAdmin = () => {
  const { handleSubmit, register, isSubmitting, errors } = useLoginForm();
  const onSubmit = useLoginAdmin();
  return <LoginForm onSubmit={handleSubmit(onSubmit)} register={register} errors={errors} isSubmitting={isSubmitting} title="管理者ログイン" btnColor="blue" />
};